export default "__VITE_ASSET__DZgmLqgP__"